<template>
    <div>
      <div class="card card-body p-0" style="border-radius: 10px">
        <case_study_table :caseStudies="caseStudies" :totalPages="totalPages" :page="page" @setPage="setPage" @setSearch="setSearch" :setSkeletonLoader="displayLoader"></case_study_table>
      </div>
    </div>
  </template>
  <script>
    import Loading from "vue-loading-overlay";
    import VueSkeletonLoader from 'skeleton-loader-vue';
    import caseStudyTable from "./case_study_table.vue";
    export default {
      components: {
        "case_study_table": caseStudyTable,VueSkeletonLoader,
        Loading,
      },
      data: function () {
        return {
          page: 1,
          search: '',
          fullPage: "",
          displayLoader: true,
        };
      },
      computed: {
        caseStudies: function () {
          return this.$store.getters["caseStudy/caseStudies"];
        },
        totalPages: function () {
          return this.$store.getters['caseStudy/totalPages'];
        },

      },
      created() {
        this.getCaseStudies(this.page,this.search)
      },
      watch: {
        page: function (val) {
          this.getCaseStudies(val,this.search)
        },

        search: function (){
          this.getCaseStudies(this.page, this.search)
        }
      },
      methods: {
        setPage(page) {
          this.page = page;
        },
        setSearch(search){
          this.search = search || ''
        },
        setSkeletonLoader(val){
          this.displayLoader = val;
          this.$forceUpdate();
        },


        getCaseStudies(page,search){
          this.setSkeletonLoader(true);
          this.$store.dispatch("caseStudy/getAllCaseStudy",[page, search])
              .then(() => {
                setTimeout(() => {
                  this.setSkeletonLoader(false);
                }, 500);
              });
        }
      },
    };
  </script>
  <style>
    .custom {
      position: absolute;
      z-index: 999;
      top: 246px;
      left: 40%;
      opacity: 0.5;
    }
  </style>